import React from "react"
import HeroSection from "./HeroSection"
import FeaturesSection from "./FeaturesSection"
import TestimonialsSection from "./TestimonialsSection"
import FAQSection from "./FAQSection"
import LatestPostsSection from "./LatestPostsSection"
import NewsletterSection from "./NewsletterSection"

// ---------------------------------------------------------------------------
// Page
// ---------------------------------------------------------------------------
export default function HomePage() {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <FeaturesSection />
      <TestimonialsSection />
      <FAQSection />
      <LatestPostsSection />
      <NewsletterSection />
    </div>
  )
}
